<div class="select-wrapper">
  @if (label) {
  <label>{{ label }}@if (required) {<span aria-hidden="true" class="asterisk">*</span>}</label>
  }
  <div class="select-style theme-default">
    <select [formControl]="formControl()">
      @for (entry of list; track entry.value) {
      <option
        [value]="entry.value"
        [disabled]="!!entry.disabled"
      >
        {{ entry.viewValue }}
      </option>
      }
    </select>
    @if (control?.invalid && (control?.dirty || control?.touched)) {
    <div class="error-msg body-1">
      {{ errorMessage() }}
    </div>
    }
  </div>
</div>
